/**
 * @file Component to present the forecast
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ChangeDetectorRef, NgZone, ElementRef } from '@angular/core';
import { ExecutorsService } from '../../executors.service';
import { PluginViewShiftsComponent } from '../plugin-view-shifts/plugin-view-shifts.component';
import { LocalisationService } from '../../../core/localisation.service';
import { DomainService } from '../../../domain.service';
import { EventsService } from '../../../core/event.service';
import { AlertsService } from '../../../core/alerts.service';
import { SettingsService } from '../../../settings.service';
import { GridService } from '../../grid.service';
/**
 * Class to show the forecast, planned and unplanned.
 */
var PluginViewShiftsExtraComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PluginViewShiftsExtraComponent, _super);
    /**
     * Creates an instance of PluginForecastShiftsExtraComponent.
     * @param {LocalisationService} localisationService LocalisationService to get langauge dependent formats.
     * @param {ChangeDetectorRef} changeDetector ChangeDetectorRef to update the component on change
     * @param {SettingsService} settingsService SettingsService has settings we need.
     * @param {ExecutorsService} executorsService ExecutorsService needed for drag/drop actions.
     * @param {DomainService} domainService DomainService to get the shifts and services.
     */
    function PluginViewShiftsExtraComponent(alertsService, localisationService, changeDetector, eventsService, settingsService, executorsService, domainService, elementRef, ngZone, gridService) {
        var _this = _super.call(this, alertsService, localisationService, changeDetector, eventsService, settingsService, executorsService, domainService, elementRef, ngZone, gridService) || this;
        /**
         * Gets the executor name. Is used to indicate the source of a drag event.
         * @type {ExecutorName}
         */
        _this.executorName = 'drop-extra';
        return _this;
    }
    /**
     * Gets the include query parameter value.
     * @protected
     * @returns The include query parameter value.
     */
    PluginViewShiftsExtraComponent.prototype.getIncludeOfTasklist = function () {
        if (!this._selectedFunction) {
            return 'Services !PURPOSES[GENERATED]';
        }
        return 'Services CONCERNS[' + this._selectedFunction['Oid'] + '] !PURPOSES[GENERATED]';
    };
    return PluginViewShiftsExtraComponent;
}(PluginViewShiftsComponent));
export { PluginViewShiftsExtraComponent };
